import axiosApiInstance from '@/api/axios'
import { NewLicenseModel } from '@/modules/LicensesPage/models/LicensesModel'
import {
  PaymentsModel,
  PaymentsRequestModel,
  PaymentsResponseModel,
} from './models/PaymentsModel'

class PaymentsService {
  async getPayments(id: string): Promise<PaymentsModel> {
    const res = await axiosApiInstance.get(`/Payments/${id}`)

    return res.data
  }

  async newLicense(data: NewLicenseModel): Promise<PaymentsResponseModel> {
    const res = await axiosApiInstance.post(`/Payments/NewLicense`, data)

    return res.data
  }

  async renewalsLicense(
    data: PaymentsRequestModel,
  ): Promise<PaymentsResponseModel> {
    const res = await axiosApiInstance.post(`/Payments/Renewals`, data)

    return res.data
  }
}

export default new PaymentsService()
